applyMerges